import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericCrudEditComponent } from 'src/app/libs/components/generic-crud/generic-crud-edit.component';
import { Checkpoint, TId, ECheckpointDataType } from 'src/app/models';
import { checkpointDataTypeSelectItems } from '../checkpoint-data-type-items';

@Component({
  selector: 'app-checkpoints-edit',
  templateUrl: './checkpoints-edit.component.html',
  styleUrl: './checkpoints-edit.component.sass',
  standalone: false,
})
export class CheckpointsEditComponent extends GenericCrudEditComponent<Checkpoint> {
  override resource = this.api.resources.checkpoints;

  readonly dataTypes = checkpointDataTypeSelectItems(this.translationService);
  sensors = this.api.resources.sensorTypes;
  ECheckpointDataType = ECheckpointDataType;

  displayEntity = () => this.entity!.name;

  initFormGroup(): FormGroup {
    const e = this.entity!;

    const isSensor = e.dataTypeId === ECheckpointDataType.Sensor;

    return this.fb.group({
      id: [e.id],
      name: [e.name],
      companyId: [e.companyId],
      dataTypeId: [e.dataTypeId],
      values: [
        isSensor
          ? (e.values && e.values.length > 0 ? e.values[0] : null)
          : (e.values && e.values.length > 0 ? e.values : null)
      ],
    });
  }

  protected override async mapFormEntity(): Promise<Partial<Checkpoint>> {
    const v = this.form!.value as Record<string, unknown>;
    let values = v['values'];
    if (values != null && !Array.isArray(values)) {
      values = [values];
    }
    const arr = Array.isArray(values)
      ? (values as unknown[]).filter(x => x != null && x !== '').map(x => String(x))
      : [];
    return {
      id: v['id'] as TId,
      name: String(v['name'] ?? ''),
      companyId: v['companyId'] as Checkpoint['companyId'],
      dataTypeId: Number(v['dataTypeId'] ?? 0) as Checkpoint['dataTypeId'],
      values: arr.length > 0 ? arr : null,
    };
  }
}
